import React, { useMemo } from 'react';
import Evaluations from './Evaluation/Evaluations';
import Result from './Result/Result';
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { MenuItem, Menu, Typography, Tooltip, IconButton } from '@mui/material';
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import Condition from './Condition/Condition';
import { addConditionForIfElse } from '../../../redux/Calculations/CalculationsActions';
import { ICalculationStep } from '../../../redux/Calculations/CurrentCalculationSessionInterface';
import { fontSize } from '../../..';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { useDispatch } from 'react-redux';
import { isFlowUsed } from '../utils';
const Conditions = ({ propKey }: { propKey: string }) => {
  const [conditionType, setConditionType] = React.useState<string>('If');

  const [anchorEl, setAnchorEl] = React.useState<null | (EventTarget & HTMLButtonElement)>(null);
  const allConditionTypes = useMemo(() => {
    return ['Else If', 'Else'];
  }, []);

  const currentCalculationSession = useSelector(
    (state: RootState) => state.calculations.properties[propKey]?.currentCalculationSession,
  );
  const dispatch = useDispatch();
  if (!currentCalculationSession) return null;
  const conditionsLength = Object.keys(
    currentCalculationSession.calculationInfo.conditionFilters,
  ).length;

  const activeFlow = currentCalculationSession.activeFlow!;
  const activeFlowConditions: ICalculationStep[] =
    currentCalculationSession.calculationInfo.flows[activeFlow];
  const safeToCreateCondition = (conditionType: string): boolean => {
    /**
     * if last  condition is "else", then it is not safe to create a new condition
     */
    if (activeFlowConditions.at(-1)?.condition === 'else') return false;
    /**
     * if last condition is "else if" then creating " else if" and "else" is safe but "if" is not safe
     */
    if (activeFlowConditions.at(-1)?.condition === 'elseIf' && conditionType === 'If') return false;
    /**
     * if last condition type is "if" then creating any condition is safe
     */
    return true;
  };
  if (!activeFlowConditions) return null;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h6"
          align="left"
          sx={{
            paddingInline: '0.5rem',
            fontSize: fontSize.large,
            fontWeight: 600,
            color: 'primary.contrastText',
          }}
        >
          Conditions
          <Typography
            component="span"
            sx={{
              textAlign: 'center',
              fontSize: '11px',
              color: '#999999',
              marginLeft: '0.3rem',
            }}
          >
            {activeFlowConditions.length} of 8
          </Typography>
        </Typography>
        <Tooltip
          title="Add Condition"
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <IconButton
            disabled={
              isFlowUsed(
                Object.keys(currentCalculationSession.calculationInfo.flows),
                currentCalculationSession.calculationInfo.flows,
                activeFlow!,
                currentCalculationSession.calculationInfo,
              ) || activeFlowConditions.length >= 8
            }
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{ padding: 0, marginRight: '0.35rem' }}
          >
            <AddCircleOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {allConditionTypes.map((conditionType, index) => {
          return (
            <MenuItem
              disabled={!safeToCreateCondition(conditionType)}
              key={index}
              sx={{ width: '5rem', fontSize: fontSize.small, color: 'primary.contrastText' }}
              onClick={() => {
                dispatch(
                  addConditionForIfElse(
                    propKey,
                    {
                      uid: activeFlow,
                      flow: 'IfElse',
                    },
                    `flt${conditionsLength + 1}`,
                    conditionType.replace(/\s+/g, ''),
                    currentCalculationSession.activeCondition!,
                  ),
                );
                setConditionType(conditionType.replace(/\s+/g, ''));
                setAnchorEl(null);
              }}
            >
              {conditionType}
            </MenuItem>
          );
        })}
      </Menu>

      <List disablePadding sx={{ paddingLeft: '0.5rem', paddingRight: '0.35rem' }}>
        {activeFlowConditions.map((condition, index: number) => {
          return <Condition key={index} index={index} condition={condition} propKey={propKey} />;
        })}
      </List>

      <Evaluations />
      <Result />
    </div>
  );
};

export default Conditions;
